<script lang="ts">
  import { onMount } from 'svelte';
  import { BulletPoint } from '../../components/index';
  import { getHref } from '../../helpers/sections-helper';
  import './css/beforeAfter.scss';
  import type { BeforeAfter } from '../types';

  export let properties: BeforeAfter;

  $: ({ button, callouts, description, headline, items } = properties);

  onMount(() => {
    document.querySelectorAll('.slider').forEach(function (slider) {
      slider.addEventListener('input', function (e) {
        const sliderPos = (e.target as HTMLInputElement).value;
        const container = closestElement(this, '.before-widget');

        // Update the width of the foreground image within the current container
        container.querySelector('.foreground-img').style.width =
          `${sliderPos}%`;

        // Update the position of the slider button within the current container
        container.querySelector('.slider-button').style.left =
          `calc(${sliderPos}% - 22px)`;
      });

      slider.addEventListener('change', function (e) {
        // Additional logic if needed for the "change" event
      });
    });

    function closestElement(element, selector) {
      while (element && !element.matches(selector)) {
        element = element.parentElement;
      }
      return element;
    }
  });
</script>

<section class="before-and-after">
  <div class="wrapper">
    <div class="before-top">
      <h2 class="h2">{@html headline?.value}</h2>
      <p class="sub-text">
        {@html description?.value}
      </p>
    </div>
    <div class="widget-holder">
      {#each items as { before, after }}
        <div class="before-widget">
          <div
            class="img background-img"
            style={`background-image: url("${before.value}")`}
          />
          <div
            class="img foreground-img"
            style={`background-image: url("${after.value}")`}
          />
          <input
            type="range"
            min="1"
            max="100"
            value="50"
            class="slider"
            name="slider"
            id="slider"
            aria-label="slider"
          />
          <div class="slider-button" />
        </div>
      {/each}
    </div>
    {#if button?.label?.length}
      <div class="bottom-boxes">
        <a
          id="before-and-after-book-now"
          class="primary-button open-form-js"
          target={button.link_type === 'External' ? '_blank' : ''}
          href={getHref(button.link_type, button.link)}>{@html button.label}</a
        >
        <div class="small-text-box">
          {#each callouts.value as item}
            <div>
              <BulletPoint bulletIcon={callouts?.icon} />
              <p class="text-small">{@html item}</p>
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </div>
</section>
